"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BAGGAGE_HEADER = exports.FIELD_NAME_VALUE_SEPARATOR = exports.ORIGIN_SVC_FIELD_NAME = exports.ORIGIN_SVC_SEPARATOR = exports.BAGGAGE_FIELD_SEPARATOR = void 0;
exports.BAGGAGE_FIELD_SEPARATOR = ',';
exports.ORIGIN_SVC_SEPARATOR = '-';
exports.ORIGIN_SVC_FIELD_NAME = 'origin-svc';
exports.FIELD_NAME_VALUE_SEPARATOR = '=';
exports.BAGGAGE_HEADER = 'baggage';
